import { render, staticRenderFns } from "./TopWaypoints.vue?vue&type=template&id=c7dc65ee&"
import script from "./TopWaypoints.vue?vue&type=script&lang=js&"
export * from "./TopWaypoints.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c7dc65ee')) {
      api.createRecord('c7dc65ee', component.options)
    } else {
      api.reload('c7dc65ee', component.options)
    }
    module.hot.accept("./TopWaypoints.vue?vue&type=template&id=c7dc65ee&", function () {
      api.rerender('c7dc65ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/TopWaypoints.vue"
export default component.exports